/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

export interface FloorPlan {
  /** Floor plan file name */
  fileName: string;
  /** Content type of the floor plan file */
  contentType: string;
  /** Size of the floor plan file in bytes */
  fileSizeInBytes: number;
  /** Binary data of the floor plan (SVG file upload) */
  floorplan?: Blob;
  /** Timestamp when the floor plan was uploaded */
  uploadedOn?: string;
}
